import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto min-h-full" }

import {
  ref,
  onBeforeMount,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useUserStore from '@/store/user';
import User from '@/models/user';
// import useAuthStore from '@/store/auth';
import { useI18n } from 'vue-i18n';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AffiliateDashboardLayout',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const {
  usersDoGetMyUser,
} = useUserStore();

const handleClose = () => {
  router.push({
    name: 'DashboardPage',
  });
};

/*
  Data
*/
const dataLoaded = ref(false);
const isLoading = ref(true);
const user = ref<User>();

/*
  Methods
*/
const loadCurrentUser = async () => {
  isLoading.value = true;
  await usersDoGetMyUser().then((response) => {
    if (!response) {
      throw new Error('User not found');
    }
    user.value = response;
    isLoading.value = false;
    dataLoaded.value = true;
  }).catch((error) => {
    alert('Erro ao carregar usuário');
    router.push({
      name: 'DashboardPage',
    });
  });
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await loadCurrentUser();
});
onMounted(() => {
  setTimeout(() => {
    dataLoaded.value = true;
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SimpleHeader, {
        "on-close": handleClose,
        pages: [
        { name: _unref(t)('sidemenu.navigation.affiliate-panel.title'), href: _unref(router).resolve({ name: 'AffiliateDashboardPage' }).href, current: true },
      ]
      }, null, 8, ["pages"]),
      (dataLoaded.value)
        ? (_openBlock(), _createBlock(_component_RouterView, {
            key: 0,
            user: user.value
          }, null, 8, ["user"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(SimpleFooter, { horizontal: true })
  ], 64))
}
}

})